module.exports = __webpack_public_path__ + "static/img/MANUFACTURING-2.964e48fd.jpg";